import { IConfigStrategy } from 'affiny-core/env';
import { EEnvPlatform } from 'affiny-core/env.types';
import { IURLContext, parseHostUrl } from 'affiny-core/services/config/parser';
import { getConfig } from 'affiny-web/src/environment/default';

export class ConfigStrategy implements IConfigStrategy {
  private context: IURLContext;

  constructor() {
    this.context = parseHostUrl(window.location.hostname);
  }

  public getPlatform() {
    return EEnvPlatform[
      process.env.REACT_APP_DEVICE === 'mobile' ? 'wam' : 'wad'
    ];
  }
  public getCountry() {
    return this.context.country;
  }
  public getLocale() {
    return this.context.locale;
  }
  public getBrand() {
    return this.context.brand;
  }
  public resetCachedCountry() {
    return Promise.resolve(true);
  }
  public getConfigOverrides() {
    const config = getConfig(this.context);

    return {
      ...config,
      envName: this.context.envName,
      origin: window.location.origin + config.publicBasePath,
    };
  }
}
